export class MenuSequenceService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    getMenuSequence(details) {
        return this._getContentSequence(details.data)
    }

    updateMenuSequence(sequenceObj, moduleName) {
        this._setResourceUrl(moduleName);
        const promise = this.menuSequenceResource.update(this._setContentSequence(sequenceObj)).$promise;

        return promise.then(response => response);
    }

    //**********************************************************Private Methods******************************** */

    _setResourceUrl(moduleName) {
        this.menuSequenceResourceUrl = this.apiService.getResourceUrl('cms/menus/${moduleName}/sequence');
        this.menuSequenceResource = this.$resource(this.menuSequenceResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }

    _getContentSequence({ content: { values } }) {
        return values.map(content => ({
            id: content.menu_id,
            sortOrder: content.sort_order,
            title: content.title
        }));
    }

    _setContentSequence(value) {
        return value.map(content => ({
            menu_id: content.id,
            sort_order: content.sortOrder
        }));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/menu-sequence/menu-sequence.service.js